// extracted by mini-css-extract-plugin
module.exports = {"header":"Index_header__2HDuy","logo":"Index_logo__3Jy_E","header_heading":"Index_header_heading__2zqu9"};